import React from 'react';
import { DollarSign } from 'lucide-react';
import { TabRevenue } from './Reports';

// Standalone page for the revenue report (surfaced in the sidebar under Reports).
export default function Revenue() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <DollarSign size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Revenue</h1>
          <p className="text-xs text-gray-400">Invoiced revenue over time</p>
        </div>
      </div>
      <TabRevenue />
    </div>
  );
}
